import React from 'react';
import { useSelector } from 'react-redux';
import { Field, FieldArray } from "redux-form";
import { Button, ReduxControls } from 'rhombus-react';
import Validators from 'widgets/forms/validators/LibraryProperties';

import "./SubmitCreativeRecipientsFields.css";

export function RenderField(member, index, fields){
	let buttonProps = {
		type:"button",
		style:"ghost",
		theme: "default",
	};

	if(fields.length -1 === index){
		buttonProps.icon = "addCircleSolid";
		buttonProps.onClick = () => fields.push();
	} else {
		buttonProps.icon = "removeCircle";
		buttonProps.onClick = () => fields.remove(index);
	}

	return (
		<div key={ member } className="recipient-row field-array-item">
			<Field
				name={ member }
				type="text"
				component={ ReduxControls.Input }
				placeholder="Enter Email Address"
				label=""
				autoFocus
				validate={[Validators.otherRecipientsEmail]}
			/>
			<Button {...buttonProps} />
		</div>
	);
}

RenderField.displayName = "RenderField";

export function RecipientRow({ fields, meta }){
	const formName = meta.form;

	const {
		userEmail,
		anyTouchedFields,
	} = useSelector((state) => {
		return {
			userEmail: state.you.email,
			anyTouchedFields: state.form[formName].anyTouched,
		};
	});



	if(fields.length === 1 && !anyTouchedFields) {
		fields.insert(0, userEmail);
	}

	return (
		<div className="recipient-row-holder custom-field-array-container e-form__control-wrapper">
			<label className="e-form__control-label other-label">Other Recipients</label>
			{ fields.map(RenderField) }
		</div>
	);
}

RecipientRow.displayName = "RecipientRow";
RecipientRow.defaultProps = {
	fields:[],
};

export function SubmitCreativeRecipientsFields() {
	return (
		<FieldArray
			name="otherRecipients"
			label="Other Recipients"
			component={ RecipientRow }
		/>
	);
}

SubmitCreativeRecipientsFields.displayName = "SubmitCreativeRecipientsFields";


export default SubmitCreativeRecipientsFields;
